import { createAction } from '@reduxjs/toolkit';
import { ViewerWrapper } from '../../../../Viewer/ViewerWrapper';
import { com } from '../../../../generated/proto-generated';

export const setSiteConfig = createAction(
  'siteConfig/setSiteConfig',
  (viewer: ViewerWrapper) => {
    return {
      payload: {
        viewer,
      },
    };
  },
);

export const setSiteActiveLayoutType = createAction(
  'siteConfig/setSiteActiveLayoutType',
  (layoutType: com.wixpress.wixdocs.ViewerConfig.LayoutType) => {
    return {
      payload: {
        layoutType,
      },
    };
  },
);

export const setScrollDirection = createAction(
  'siteConfig/setScrollDirection',
  (scrollDirection: string) => {
    return {
      payload: {
        scrollDirection,
      },
    };
  },
);
